import { Table as BaseTable } from './container'
import * as cellRenderers from './cellRenderers'

export { TableController as TableControllerHost } from './components/tableController'
export { TableContext } from './components/tableController/context'

export const Table = Object.assign(BaseTable, {
  CellRenderers: cellRenderers,
})
